'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');

const booleanInputRoot = "_boolean-input-root_75wb5_1";
const booleanInputInner = "_boolean-input-inner_75wb5_7";
const booleanInputLayer = "_boolean-input-layer_75wb5_62";
const styles = {
	booleanInputRoot: booleanInputRoot,
	booleanInputInner: booleanInputInner,
	booleanInputLayer: booleanInputLayer
};

const BooleanInput = ({ type, "aria-label": ariaLabel = void 0, checked = false, disabled = void 0, id = void 0, isErrored = void 0, isRequired = void 0, name = void 0, onChange = () => {
}, tabIndex = 0, value = void 0 }) => {
  return jsxRuntime.jsx("span", { className: styles.booleanInputRoot, "data-zds": true, children: jsxRuntime.jsxs("span", { className: styles.booleanInputInner, "data-zds": true, "data-type": type, "data-checked": checked, "data-errored": isErrored, "data-disabled": disabled, children: [jsxRuntime.jsx("input", { "aria-label": ariaLabel, checked, className: styles.booleanInputLayer, disabled, id, name, onChange, required: isRequired, tabIndex, type, value, "data-zds": true }), checked && jsxRuntime.jsx("span", { className: styles.booleanInputLayer, "data-zds": true, children: jsxRuntime.jsx(components_display_Icon_Icon.Icon, { isBlock: true, name: {
    checkbox: "formCheck",
    radio: "formRadioDot"
  }[type], size: 18 }) })] }) });
};

exports.BooleanInput = BooleanInput;
//# sourceMappingURL=BooleanInput.cjs.js.map
